export { env } from './env';
export const SENTRY_DSN = 'https://e9a62875e24a4faba73e3ff482f65a77@o402067.ingest.sentry.io/5950168'